import { useState, useEffect } from "react";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

//  React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

//  React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useParams } from "react-router-dom";
import { EmailRounded, Save } from "@mui/icons-material";
import FormField from "./components/FormField";
import MDTypography from "components/MDTypography";
import { Autocomplete } from "@mui/material";
import MDInput from "components/MDInput";
import { useAuth } from "utils/AuthProvider";
import { API_URL } from "context/dataContext";
import FileUpload from "components/FileUpload";

import { v4 as uuidv4 } from "uuid";

const axios = require("axios").default;

function EditPatient() {
  const { cookies } = useAuth();
  axios.defaults.headers.common = { Authorization: `Bearer ${cookies.token}` };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [complete, setComplete] = useState("");
  const [assignedname, setAssignName] = useState("");
  const [assignedphone, setAssignPhone] = useState("");
  const [type, setType] = useState("IPD");
  const [_id, set_Id] = useState();
  const [logtitle, setLogTitle] = useState("");
  const [logdetails, setLogDetails] = useState("");
  const [patient, setPatient] = useState();
  const [logs, setLogs] = useState([]);
  const [currentLogId, setCurrentLogId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const { id } = useParams();
  console.log(id);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleDiagnosisChange = (e) => {
    setDiagnosis(e.target.value);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleAssignNameChange = (e) => {
    setAssignName(e.target.value);
  };

  const handleAssignPhoneChange = (e) => {
    setAssignPhone(e.target.value);
  };

  const handleLogTitleChange = (e) => {
    setLogTitle(e.target.value);
  };

  const handleLogDetailsChange = (e) => {
    setLogDetails(e.target.value);
  };

  useEffect(() => {
    axios
      .post(`${API_URL}/api/patients/patientid`, {
        id: id,
      })
      .then(function (response) {
        console.log(response.data);
        if (response.data.status === "patient found") {
          const Patient = response.data.patient;
          //const Patient = PatientJson.find((item) => item.id === parseInt(id));

          set_Id(Patient ? Patient._id : "");
          setPatient(Patient);
          setName(Patient ? Patient.name : "");
          setEmail(Patient ? Patient.email : "");
          setPhone(Patient ? Patient.number : "");
          setDiagnosis(Patient ? Patient.diagnosis : "");
          setStartDate(Patient ? Patient.start_date : "");
          setEndDate(Patient ? Patient.end_date : "");
          setStatus(Patient ? Patient.status : "");
          setComplete(Patient ? Patient.completed : "");
          setAssignName(Patient ? Patient.assignedname : "");
          setAssignPhone(Patient ? Patient.assignedphone : "");
          setType(Patient ? Patient.type : "");

          if (Patient.type === "OPD") {
            axios
              .post(`${API_URL}/api/patientlogs/find`, {
                patient: Patient._id,
              })
              .then(function (response) {
                console.log(response.data);
                setLogs(response.data);
                //window.location.href = '/dashboards/analytics'
              })
              .catch(function (error) {
                console.log(error);
              });
          }

          //setInitialValues(tempInitialValues);
          //console.log(initialValues);
        }
      })
      .catch(function (error) {
        alert("Something went wrong");
        console.log(error);
      });
  }, [id]); // Add email to the dependency array

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const submitForm = async () => {
    await sleep(1000);

    axios
      .post(`${API_URL}/api/patients/details`, {
        id: id,
        name: name,
        email: email,
        number: phone,
        status: status,
        completed: complete,
        diagnosis: diagnosis,
        start_date: start_date,
        end_date: end_date,
        type: type,
      })
      .then(function (response) {
        console.log(response.data);
        if (response.data === "data saved") {
          alert("Patient Updated");
        }

        //window.location.href = '/dashboards/analytics'
      })
      .catch(function (error) {
        alert("Something went wrong");
        //openErrorSB()
        console.log(error);
      });
  };

  const SaveAssign = async () => {
    await sleep(1000);

    axios
      .post(`${API_URL}/api/patients/backend`, {
        id: id,
        assignedname: assignedname,
        assignedphone: assignedphone,
      })
      .then(function (response) {
        console.log(response.data);
        if (response.data === "data saved") {
          alert("Patient Assigned");
        }

        //window.location.href = '/dashboards/analytics'
      })
      .catch(function (error) {
        alert("Something went wrong");
        //openErrorSB()
        console.log(error);
      });
  };

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const SaveLog = async () => {
    // Validate form fields
    if (!logtitle.trim()) {
      alert("Please enter a test name/title");
      return;
    }

    if (!logdetails.trim()) {
      alert("Please enter test details");
      return;
    }

    console.log("SaveLog called. uploadedFiles:", uploadedFiles);

    axios
      .post(`${API_URL}/api/patientlogs/add`, {
        id: uuidvNumbers(),
        title: logtitle,
        details: logdetails,
        created_on: new Date(),
        patient: patient._id,
        attachments: [],
      })
      .then(async (response) => {
        console.log("Log created:", response.data);

        const newLogId = response.data.result._id;
        console.log("New log ID:", newLogId);
        setCurrentLogId(newLogId);

        // If there are files to upload, upload them
        if (uploadedFiles && uploadedFiles.length > 0) {
          console.log("Uploading", uploadedFiles.length, "files...");
          try {
            const formData = new FormData();

            // Add files to FormData - handle both new File objects and existing attachment objects
            uploadedFiles.forEach((item, idx) => {
              console.log(`Processing file ${idx}:`, {
                hasFile: !!item.file,
                isFile: item.file instanceof File,
                fileName: item.file?.name,
              });

              if (item.file && item.file instanceof File) {
                formData.append("files", item.file);
                console.log(`Added file ${idx} to FormData: ${item.file.name}`);
              }
            });

            // Check if any files were actually added
            const fileCount = formData.getAll("files").length;
            console.log("Total files in FormData:", fileCount);

            if (fileCount === 0) {
              console.warn("No valid files found in uploadedFiles array");
              alert("No valid files to upload");
              return;
            }

            // Add logId to body
            formData.append("logId", newLogId);

            console.log("Uploading files to log:", newLogId);
            const uploadResponse = await axios.post(
              `${API_URL}/api/patientlogs/upload-attachment`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            console.log("Files uploaded successfully:", uploadResponse.data);
          } catch (uploadError) {
            console.error("Error uploading files:", uploadError);
            console.error("Error response:", uploadError.response?.data);
            alert(
              "Log created but file upload failed: " +
                (uploadError.response?.data?.message || uploadError.message)
            );
          }
        } else {
          console.log("No files to upload. uploadedFiles length:", uploadedFiles.length);
        }

        // Clear form fields
        setLogTitle("");
        setLogDetails("");
        setUploadedFiles([]);

        // Refresh logs
        axios
          .post(`${API_URL}/api/patientlogs/find`, {
            patient: patient._id,
          })
          .then((response) => {
            console.log("Logs refreshed:", response.data);
            setLogs(response.data);
            alert("Test log saved successfully");
          })
          .catch((error) => {
            console.log("Error refreshing logs:", error);
          });
      })
      .catch((error) => {
        alert("Something went wrong while saving the log");
        console.log("Error creating log:", error);
      });
  };

  const handleFileUpload = async (filesData) => {
    try {
      console.log("handleFileUpload called - auto-saving files to state:", filesData);

      // Store the file objects in uploadedFiles for later use when SaveLog is clicked
      const fileObjects = filesData.map(({ file, name, size }) => {
        console.log("Storing file:", { name, size, isFile: file instanceof File });
        return {
          file,
          name: file.name,
          size: file.size,
        };
      });

      console.log("File objects to store:", fileObjects);
      setUploadedFiles((prev) => {
        const updated = [...prev, ...fileObjects];
        console.log("Updated uploadedFiles state:", updated);
        return updated;
      });
      console.log("Files auto-saved to state. They will be uploaded when you click 'Add Log'");
    } catch (error) {
      console.error("Error storing files:", error);
      alert("Error adding files: " + error.message);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} mb={20} height="65vh">
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={8} lg={8}>
            <Card autoComplete="off" sx={{ height: "100%" }}>
              <MDBox p={3} pb={0}>
                <MDTypography variant="h5">Edit - {name}</MDTypography>
              </MDBox>

              <MDBox p={3}>
                <MDBox component="form" pb={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="text"
                        value={name}
                        onChange={handleNameChange}
                        label="Full Name"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="email"
                        value={email}
                        onChange={handleEmailChange}
                        label="Email"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="tel"
                        value={phone}
                        onChange={handlePhoneChange}
                        label="Phone"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="date"
                        value={start_date}
                        onChange={handleStartDateChange}
                        label="Start Date"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="date"
                        value={end_date}
                        onChange={handleEndDateChange}
                        label="End Date"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="text"
                        value={diagnosis}
                        onChange={handleDiagnosisChange}
                        label="Diagnosis"
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        options={["IPD", "OPD"]}
                        value={type || null}
                        onChange={(event, newValue) => {
                          setType(newValue);
                        }}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <MDInput {...params} label="Type" variant="standard" />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        options={["Awaiting", "Approved", "Rejected"]}
                        value={status || null}
                        onChange={(event, newValue) => {
                          setStatus(newValue);
                        }}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <MDInput {...params} label="Status" variant="standard" />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        options={["Completed", "Incomplete"]}
                        value={complete || null}
                        onChange={(event, newValue) => {
                          setComplete(newValue);
                        }}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <MDInput {...params} label="Complete" variant="standard" />
                        )}
                      />
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox mt={2} gap={2} width="100%" display="flex" justifyContent="flex-start">
                  <MDButton variant="gradient" color="primary" onClick={submitForm}>
                    Save
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={4} lg={4}>
            <Card autoComplete="off" sx={{ height: "100%", margin: "20px" }}>
              <MDBox p={3} pb={0}>
                <MDTypography variant="h5">Assign Patient</MDTypography>
              </MDBox>

              <MDBox p={3}>
                <MDBox component="form" pb={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="text"
                        value={assignedname}
                        onChange={handleAssignNameChange}
                        label="Assign Name"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormField
                        type="text"
                        value={assignedphone}
                        onChange={handleAssignPhoneChange}
                        label="Assign Phone"
                      />
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox mt={2} gap={2} width="100%" display="flex" justifyContent="flex-start">
                  <MDButton variant="gradient" color="primary" onClick={SaveAssign}>
                    Assign
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          {type === "OPD" ? (
            <Grid item xs={12} lg={12} mt={3}>
              <Card autoComplete="off" sx={{ height: "100%" }}>
                <MDBox p={3} pb={0}>
                  <MDTypography variant="h5">Tests</MDTypography>
                </MDBox>

                <MDBox p={3}>
                  <MDBox component="form" pb={3}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormField
                          type="text"
                          value={logtitle}
                          onChange={handleLogTitleChange}
                          label="Test Name/Title"
                        />
                        <FormField
                          type="details"
                          multiline
                          rows={4}
                          value={logdetails}
                          onChange={handleLogDetailsChange}
                          label="Test Details"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <MDTypography variant="h5">Images/Prescriptions</MDTypography>
                        <MDBox sx={{ mt: 2 }}>
                          <FileUpload
                            onFilesSelected={handleFileUpload}
                            existingFiles={uploadedFiles}
                            acceptedFileTypes=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                          />
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>

                  <MDBox mt={2} gap={2} width="100%" display="flex" justifyContent="flex-start">
                    <MDButton variant="gradient" color="primary" onClick={SaveLog}>
                      Add Log
                    </MDButton>
                  </MDBox>

                  <MDBox pt={3}>
                    <MDTypography variant="h5">History</MDTypography>
                  </MDBox>
                  <MDBox>
                    {logs.map((log) => (
                      <MDBox key={log._id} p={2} style={{ borderBottom: "1px solid #ccc" }}>
                        <MDTypography variant="caption" color="text">
                          {new Date(log.created_on).toLocaleDateString()}
                        </MDTypography>
                        <MDTypography variant="h6">{log.title}</MDTypography>
                        <MDTypography variant="caption">{log.details}</MDTypography>
                        {log.attachments && log.attachments.length > 0 && (
                          <MDBox sx={{ mt: 1 }}>
                            <MDTypography variant="caption" color="primary">
                              Attachments: {log.attachments.length}
                            </MDTypography>
                            <MDBox
                              sx={{
                                mt: 2,
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                                gap: 2,
                              }}
                            >
                              {log.attachments.map((attachment, idx) => {
                                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(attachment.filename);
                                return (
                                  <MDBox
                                    key={idx}
                                    sx={{
                                      border: "1px solid #ddd",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      backgroundColor: "#f9f9f9",
                                      transition: "transform 0.2s",
                                      "&:hover": {
                                        transform: "scale(1.02)",
                                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                      },
                                    }}
                                  >
                                    {isImage ? (
                                      <MDBox
                                        component="img"
                                        src={attachment.url}
                                        alt={attachment.filename}
                                        sx={{
                                          width: "100%",
                                          height: "120px",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          window.open(attachment.url, "_blank");
                                        }}
                                      />
                                    ) : (
                                      <MDBox
                                        sx={{
                                          width: "100%",
                                          height: "120px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor: "#e3f2fd",
                                        }}
                                      >
                                        <MDTypography
                                          variant="caption"
                                          sx={{ textAlign: "center", px: 1 }}
                                        >
                                          📄 {attachment.filename.split(".").pop().toUpperCase()}
                                        </MDTypography>
                                      </MDBox>
                                    )}
                                    <MDBox sx={{ p: 1 }}>
                                      <MDTypography
                                        variant="caption"
                                        sx={{
                                          display: "block",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          mb: 1,
                                        }}
                                        title={attachment.filename}
                                      >
                                        {attachment.filename}
                                      </MDTypography>
                                      <MDButton
                                        variant="gradient"
                                        color="primary"
                                        size="small"
                                        fullWidth
                                        onClick={() => {
                                          const link = document.createElement("a");
                                          link.href = attachment.url;
                                          link.download = attachment.filename;
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }}
                                        sx={{ py: 0.5 }}
                                      >
                                        Download
                                      </MDButton>
                                    </MDBox>
                                  </MDBox>
                                );
                              })}
                            </MDBox>
                          </MDBox>
                        )}
                      </MDBox>
                    ))}
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default EditPatient;
